// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33uy9","field":"styles_field__2VZlb","fieldCol":"styles_fieldCol__3LHXJ","diffCol":"styles_diffCol__IJQDW","diff":"styles_diff__fUxqP"};